import axios from 'axios'
import Cookies from 'js-cookie'
import AppRoutePath from '../../router/AppRoutePath';

let refreshTokenPromise;

const getRefreshToken = async () => {
    console.log("[i] response unauth, token expire, need refresh");

    // if error happened here it would be thrown up to the caller
    try {
        if (!Cookies.get("refresh_token")) {
            console.log("refresh token not exist")
            throw "refresh token not exist"
        }
        const refreshResp = await axios.get(process.env.REACT_APP_BASE_API_URL + "auth/refresh", {
            headers: {
                Authorization: "Bearer " + Cookies.get("refresh_token")
            }
        });
        const { access_token, refresh_token } = refreshResp.data.data;
        console.log("set access token from refresh")
        Cookies.set("access_token", access_token);

        if (refresh_token) {
            Cookies.set("refresh_token", refresh_token);
        }
    } catch (error) {
        Cookies.remove("refresh_token");
        Cookies.remove("access_token");
        Cookies.remove("firebase_token");
        window.location.href = AppRoutePath.LOGIN;
    }
}

// Add a request interceptor
// axios.interceptors.request.use((config)=> {
//     // Do something before request is sent
//     return config;
// }, (error)=> {
//     // Do something with request error
//     return Promise.reject(error);
// });

// Add a response interceptor
axios.interceptors.response.use((response) => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    // console.log("response okay")
    return response;
}, (error) => {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error 
    return new Promise((resolve, reject) => {

        if (error.response.status === 401 && error.response.headers["token-expire"]) {
            console.log("interceptor error token expired")
            if (!refreshTokenPromise) {
                refreshTokenPromise = getRefreshToken().then(() => {
                    refreshTokenPromise = null;
                    // window.location.reload();
                }).catch(err => {
                    return reject(err)
                })
            }

            refreshTokenPromise.then(() => {
                if (!Cookies.get('access_token')) throw "No token"

                console.log("access token received")

                let newConfig = error.response.config
                newConfig.headers['Authorization'] = "Bearer " + Cookies.get("access_token")

                axios.request(newConfig).then((response) => {
                    return resolve(response)
                }).catch(err => {
                    return reject(err)
                })

            }).catch(err => {
                return reject(err)
            })

        } else {
            console.log("interceptor error not token expired")
            return reject(error)
        }
    })
});